export class ResponseResult {
    status: number = 500;
    data: any = null;
    description: string = "";
    pagination: any = null;

    constructor() {
    }
}
